import { useEffect, useState } from "react";
import { getOrganizers } from "../../../api/company.api";

export function useOrganizers() {
  const [companies, setOrganizers] = useState([]); 
  const [loading, setLoading] = useState(false);

  const loadOrganizers = async () => {
    setLoading(true);
    try {
      const res = await getOrganizers();
      setOrganizers(res?.data || []);
    } catch (e) {
      setOrganizers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadOrganizers();
  }, []);

  return { companies, loading };
}
